export type BookingLocation = {
  LocationId: string;
  Name: string;
  Phone?: string;
  Address?: string;
};

export type BookingSlot = {
  Time: string;
  Capacity: number;
  Booked: number;
  Available: boolean;
};

export type BookingAvailabilityDate = {
  BookingAvailabilityId?: string | null;
  LocationId: string;
  LocationName: string;
  AppointmentDate: string;
  IsOpen: boolean;
  Slots: BookingSlot[];
  RawSlots?: string[];
  SlotCapacity: number;
  IsNationalHoliday: boolean;
  Note?: string | null;
  UpdatedAt?: string | null;
};

type ApiResponse<T> = T & { ok: boolean; message?: string };

async function parseJsonResponse<T>(response: Response): Promise<T> {
  const data = (await response.json().catch(() => ({}))) as ApiResponse<T>;
  if (!response.ok || data.ok === false) {
    throw new Error(data.message || "可預約時段載入失敗，請稍後再試。");
  }
  return data as T;
}

export async function fetchBookingAvailability(params: {
  LocationId?: string;
  Store?: string;
  StartDate?: string;
  EndDate?: string;
}) {
  const query = new URLSearchParams();
  if (params.LocationId) query.set("LocationId", params.LocationId);
  if (params.Store) query.set("Store", params.Store);
  if (params.StartDate) query.set("StartDate", params.StartDate);
  if (params.EndDate) query.set("EndDate", params.EndDate);
  const suffix = query.toString() ? `?${query.toString()}` : "";
  return fetch(`/api/booking-availability${suffix}`, {
    credentials: "include",
    headers: { Accept: "application/json" },
  }).then((response) => parseJsonResponse<{
    ok: boolean;
    Locations: BookingLocation[];
    SelectedLocationId: string | null;
    BookingPublicLookaheadDays?: number;
    Dates: BookingAvailabilityDate[];
  }>(response));
}
